<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             width="600px"
             @open="handleOpen"
             @close="clickClose">
        <div class="row">
            <div class="col-12">
                <x-table-server ref="refStoreTableServer"
                                :title="title"
                                :resource="resource_documents"
                                :additional-filters="[
                                    {'field': 'table', 'value': table},
                                    {'field': 'document_type_id', 'value': documentTypeId},
                                    {'field': 'person_id', 'value': personId},
                                ]"
                                :show-section-title="false"
                                :show-filter="false"
                                :show-button-new="false"
                                :show-button-columns="false"
                                :show-button-export="false"
                                v-if="loadForm">
                    <template v-slot:table-rows="props">
                        <tr v-for="row in props.records">
                            <td v-for="col in props.columns" :class="col.class_col_body" :key="col['name']">
                                <template v-if="col['name'] === 'actions'">
                                    <x-button-icon icon="fa-light fa-plus"
                                                   class="x-button-icon-small"
                                                   @click="getItems(row.id)"></x-button-icon>
                                </template>
                                <!--                                <template v-else-if="col['name'] === 'date_of_issue'">-->
                                <!--                                    {{ row.date_of_issue }}<br/>{{ row.time_of_issue }}-->
                                <!--                                </template>-->
                                <template v-else>
                                    {{ row[col['name']] }}
                                </template>
                            </td>
                        </tr>
                    </template>
                </x-table-server>
            </div>
            <div class="col-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../components/Form/XButtonCancel";
import XModal from "../../../components/XModal";
import XTableServer from "../../../components/Form/XTableServer.vue";
import XButtonIcon from "../../../components/Form/XButtonIcon.vue";

export default {
    name: 'StoreDocumentItems',
    components: {XButtonIcon, XTableServer, XModal, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        resource: {
            type: String,
            required: true,
        },
        table: {
            type: String,
        },
        personId: {
            required: true,
        },
        documentTypeId: {
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            loadForm: false,
            title: null,
            resource_documents: null,
            records: []
        }
    },
    methods: {
        initForm() {
            this.title = 'Listado de comprobantes';
            this.resource_documents = `store/documents`;
            this.records = []
        },
        async handleOpen() {
            this.initForm();
            this.loadForm = true;
        },
        async getItems(id) {
            this.loading = true
            await this.$http.post(`/${this.resource_documents}/get_items`, {
                'id': id,
                'table': this.table
            })
                .then(response => {
                    this.$emit('success', response.data)
                    console.log(response.data)
                });
            this.loading = false
        },
        clickClose() {
            this.$emit('update:showDialog', false)
            this.initForm()
            this.loadForm = false;
        },
    }
}
</script>
